/*
  We'll add a 30-min expiry (exp) so rooms won't linger too long on your account.
  See other available options at https://docs.daily.co/reference#create-room
 */
async function createRoom() {
  // const exp = Math.round(Date.now() / 1000) + 60 * 30;
  const options = {
    properties: {
      max_participants: 3,
      // auto_start_transcription: true,
      // auto_transcription_settings: {
      //   experimental: true,
      // },
      // enable_transcription_storage: false,
      // enable_live_captions_ui: true,
      // exp,
    },
  };

  const isLocal = process.env.NODE_ENV === 'development';
  const endpoint = isLocal
    ? 'https://api.daily.co/v1/rooms/'
    : `${window.location.origin}/.netlify/functions/rooms`;
  /*
    No need to send the headers with the request when using the proxy option:
    netlify.toml takes care of that for us.
  */
  const createDailyHeaders = async (useEnv) => {
    if (useEnv) {
      // Local: usa a chave diretamente (se ainda tiver no .env)
      return {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${process.env.REACT_APP_DAILY_API_KEY}`,
        }
      };
    }
      // Produção: busca da function
    const response = await fetch(`${window.location.origin}/.netlify/functions/daily-config`);
    const config = await response.json();

    return {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${config.apiKey}`,
      }
    };
  };

  // Usar assim:
  const headers = await createDailyHeaders(isLocal);

  const startTime = Date.now();
  const info = {
    endpoint,
    startedAt: startTime,
    status: 'pending',
  };

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      body: JSON.stringify(options),
      ...headers,
    });

    info.durationMs = Date.now() - startTime;
    info.status = response.ok ? 'success' : 'error';
    info.httpStatus = response.status;

    const jsonResponse = await response.json();
    info.response = jsonResponse;

    document.dispatchEvent(new CustomEvent('api:room:create:completed', { detail: info }));

    if (!response.ok) {
      throw new Error(`Failed to create room: ${response.status}`);
    }

    return jsonResponse;
  } catch (error) {
    info.durationMs = Date.now() - startTime;
    info.status = 'failed';
    info.error = error?.message || 'unknown error';
    document.dispatchEvent(new CustomEvent('api:room:create:completed', { detail: info }));
    throw error;
  }
}

export default { createRoom };
